import React from 'react';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import { fireUIAnalytics, AnalyticsEventToProps } from '@atlassian/jira-product-analytics-bridge';
import { type LinkProps, Link } from '@atlassian/react-resource-router';

export const LinkWithAnalyticsBase = AnalyticsEventToProps('link', {
	onClick: 'clicked',
})(Link);

export type Props = LinkProps & {
	action?: string;
	actionSubject?: string;
	actionSubjectId?: string;
	attributes?: {
		[key: string]: string | boolean | number;
	};
};

export const LinkWithAnalytics = ({
	action,
	actionSubject,
	actionSubjectId = '',
	attributes = {},
	...props
}: Props): React.JSX.Element => (
	<LinkWithAnalyticsBase
		{...props}
		// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
		onClick={(_, analyticsEvent: UIAnalyticsEvent) => {
			const { payload } = analyticsEvent;
			analyticsEvent.update({
				action: typeof action !== 'undefined' ? action : payload.action,
				actionSubject: typeof actionSubject !== 'undefined' ? actionSubject : payload.actionSubject,
			});
			fireUIAnalytics(analyticsEvent, actionSubjectId, attributes);
			if (props.onClick) {
				// @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
				props.onClick();
			}
		}}
	/>
);
